export function decorateUrl(urlString) {
    const ga = window[window['GoogleAnalyticsObject']];
    let tracker;
    if (ga && typeof ga.getAll === 'function') {
        tracker = ga.getAll()[0];
        urlString = new window.gaplugins.Linker(tracker).decorate(urlString);
    }
    return urlString;
}
